import { useEffect, useRef, useState } from "react";
// routes that should not trigger the session timeout
const ExcludedRoutes = [
	"/",
	"/login",
	"/member/login",
	"/verify-email",
	"/verification",
	"/guest/login",
	"/guest/signup",
	"/two-factor",
	"/thank-you",
	"/two-factor-setup",
];
const useSessionTimeout = () => {
	const events = ["mousemove", "keydown", "scroll", "click"];
	const timeout = 15 * 60 * 1000; //15 minutes
	const [isSessionTimeout, setIsSessionTimeout] = useState(false);
	const timerRef = useRef(null);

	const resetTimer = () => {
		const isExcluded = ExcludedRoutes.some(
			(route) => window.location.pathname === route
		);
		if (isExcluded) return;
		if (timerRef.current) clearTimeout(timerRef.current);

		setIsSessionTimeout(false);

		timerRef.current = setTimeout(() => {
			setIsSessionTimeout(true);
		}, timeout);
	};

	useEffect(() => {
		events.forEach((event) => window.addEventListener(event, resetTimer));
		resetTimer(); // initialize timer on mount

		return () => {
			events.forEach((event) => window.removeEventListener(event, resetTimer));
			if (timerRef.current) clearTimeout(timerRef.current);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [timeout, events]);

	return { isSessionTimeout };
};

export default useSessionTimeout;
